import React, { useContext, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import Navbar from '../components/Navbar';
import ProductTable from '../components/ProductTable';
import StickyCartButton from '../components/StickyCartButton';
import Footer from '../components/Footer';
import AppContext from '../contexts/AppContext';

const ProductsPage = () => {
  const { dispatch } = useContext(AppContext);
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  // search term store
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await axios.get('https://ak-carckers-backend-api.onrender.com/api/products');
        setProducts(response.data);
        dispatch({ type: 'SET_PRODUCTS', payload: response.data });
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    };
    fetchProducts();
  }, [dispatch]);


  const filteredProducts = products.filter((product) =>
    product.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="page-shell">
      <Navbar />
      <main className="container py-4">
        <div className="d-flex flex-column flex-md-row justify-content-between align-items-start gap-3 mb-4">
          <div>
            <h1 className="h3 mb-2">AK Crackers Shop</h1>
            <p className="text-muted">Choose your products and select quantities. Cart updates automatically.</p>
          </div>
          <div className="text-end w-100 w-md-auto">
            <Link to="/" className="btn btn-outline-secondary btn-sm mb-2 mb-md-0 me-md-2 d-inline-block">Back to home</Link>
          </div>
        </div>

        {/* --- Search Bar Section  --- */}
        {/* --- Search Bar Section Fix Macha --- */}
        <div className="row mb-4">
          <div className="col-12 col-md-6 col-lg-4">
            <div className="input-group custom-search-group shadow-sm">
              <span className="input-group-text custom-search-addon" id="search-addon">
                🔍
              </span>
              <input
                type="text"
                className="form-control custom-search-input"
                placeholder="Search crackers..."
                aria-label="Search Crackers"
                aria-describedby="search-addon"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
              {searchTerm && (
                <button
                  className="btn custom-search-clear fw-bold"
                  type="button"
                  onClick={() => setSearchTerm('')}
                >
                  ✕
                </button>
              )}
            </div>
          </div>
        </div>
        {/* ------------------------------- */}

        {loading ? (
          <div className="text-center py-5">Loading products...</div>
        ) : filteredProducts.length > 0 ? (

          <ProductTable products={filteredProducts} />
        ) : (
          <div className="text-center py-5 text-muted fw-bold">
            "❌ There are no matching crackers! Try typing something else!"
          </div>
        )}
      </main>
      <StickyCartButton />
    </div>
  );
};

export default ProductsPage;